'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = TextInput;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames3 = require('classnames');

var _classnames4 = _interopRequireDefault(_classnames3);

var _reactProptypeConditionalRequire = require('react-proptype-conditional-require');

var _reactProptypeConditionalRequire2 = _interopRequireDefault(_reactProptypeConditionalRequire);

var _WarningCircle = require('@deliveroo/icon-set/react/WarningCircle');

var _WarningCircle2 = _interopRequireDefault(_WarningCircle);

var _omit = require('../../utils/omit');

var _omit2 = _interopRequireDefault(_omit);

var _Icon = require('../Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _P = require('../P');

var _P2 = _interopRequireDefault(_P);

var _LoadingIndicator = require('../LoadingIndicator');

var _LoadingIndicator2 = _interopRequireDefault(_LoadingIndicator);

var _Label = require('../../internal/Label');

var _Label2 = _interopRequireDefault(_Label);

var _SpacerElement = require('../../internal/SpacerElement');

var _SpacerElement2 = _interopRequireDefault(_SpacerElement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var styles = {
  'textInput': 'ccl-62c56e43ff6d61d7',
  'wrapper': 'ccl-4db481fa4a66a72d',
  'input': 'ccl-f67359d1c16a266a',
  'withIcon': 'ccl-ba10c96cdddaeba3',
  'withIconContent': 'ccl-6c7da45c9a5c91a4',
  'iconWrapper': 'ccl-8275ba034cf3bad7',
  'icon': 'ccl-f1a13f867fc3f631',
  'loading': 'ccl-1c1a68f075d43fbf',
  'invalid': 'ccl-e85654fc6a5253cd',
  'invalidIcon': 'ccl-5e876863a0298aca',
  'placeholder': 'ccl-3b2ac35bde68b502'
};

/**
 * A generic text input component.
 */

function TextInput(_ref) {
  var _classnames2;

  var value = _ref.value,
      label = _ref.label,
      icon = _ref.icon,
      id = _ref.id,
      name = _ref.name,
      rows = _ref.rows,
      type = _ref.type,
      inputRef = _ref.inputRef,
      placeholder = _ref.placeholder,
      isInvalid = _ref.isInvalid,
      isLoading = _ref.isLoading,
      iconContent = _ref.iconContent,
      extraContent = _ref.extraContent,
      errorMessage = _ref.errorMessage,
      helpMessage = _ref.helpMessage,
      autoComplete = _ref.autoComplete,
      isAutoCompleteDisabled = _ref.isAutoCompleteDisabled,
      isSpellCheckDisabled = _ref.isSpellCheckDisabled,
      isRequired = _ref.isRequired,
      onChange = _ref.onChange,
      isPlaceholder = _ref.isPlaceholder,
      spacing = _ref.spacing,
      adjacentVerticalSpacing = _ref.adjacentVerticalSpacing,
      adjacentHorizontalSpacing = _ref.adjacentHorizontalSpacing,
      otherProps = _objectWithoutProperties(_ref, ['value', 'label', 'icon', 'id', 'name', 'rows', 'type', 'inputRef', 'placeholder', 'isInvalid', 'isLoading', 'iconContent', 'extraContent', 'errorMessage', 'helpMessage', 'autoComplete', 'isAutoCompleteDisabled', 'isSpellCheckDisabled', 'isRequired', 'onChange', 'isPlaceholder', 'spacing', 'adjacentVerticalSpacing', 'adjacentHorizontalSpacing']);

  var getInputMode = function getInputMode() {
    switch (true) {
      case type === 'number':
        return 'numeric';
      case type === 'text':
        return 'verbatim';
      default:
        return type;
    }
  };

  var getAutoComplete = function getAutoComplete() {
    if (autoComplete) {
      return autoComplete;
    }

    switch (true) {
      case isAutoCompleteDisabled && type === 'password':
        return 'new-password';
      case isAutoCompleteDisabled:
        return 'off';
      case type === 'tel':
      case type === 'email':
        return type;
      default:
        return undefined;
    }
  };

  var getFormElement = function getFormElement(formProps) {
    if (type === 'text' && rows > 1) {
      return _react2.default.createElement('textarea', _extends({ id: id, rows: rows }, formProps));
    }

    return _react2.default.createElement('input', _extends({ id: id, type: type, inputMode: getInputMode() }, formProps));
  };

  var getHelpMessage = function getHelpMessage() {
    if (typeof helpMessage === 'string') {
      return _react2.default.createElement(
        _P2.default,
        { size: 'x-small', color: 'grey', adjacentVerticalSpacing: 'small' },
        helpMessage
      );
    }

    return helpMessage;
  };

  var getErrorMessage = function getErrorMessage() {
    if (typeof errorMessage === 'string') {
      return _react2.default.createElement(
        _P2.default,
        { size: 'x-small', color: 'red', adjacentVerticalSpacing: 'small' },
        errorMessage
      );
    }

    return errorMessage;
  };

  var getIconContent = function getIconContent() {
    switch (true) {
      case isLoading:
        return _react2.default.createElement(
          'div',
          { className: styles.loading },
          _react2.default.createElement(_LoadingIndicator2.default, null)
        );
      case !!iconContent:
        return iconContent();
      case isInvalid:
        return _react2.default.createElement(
          'div',
          { className: styles.invalidIcon },
          _react2.default.createElement(_Icon2.default, { component: _WarningCircle2.default, color: 'red', size: 18 })
        );
      default:
        return null;
    }
  };

  var wrapperClassNames = (0, _classnames4.default)(styles.wrapper, _defineProperty({}, styles.invalid, isInvalid));

  var formProps = _extends({
    className: (0, _classnames4.default)(styles.input, (_classnames2 = {}, _defineProperty(_classnames2, styles.withIcon, !!icon), _defineProperty(_classnames2, styles.withIconContent, !!iconContent || isLoading), _classnames2)),
    placeholder: placeholder,
    autoComplete: getAutoComplete(),
    spellCheck: !isSpellCheckDisabled,
    autoCorrect: !isSpellCheckDisabled ? 'on' : 'off', // Safari-only; disabled if spellcheck is also disabled
    name: name,
    required: isRequired,
    'aria-invalid': isInvalid,
    'aria-required': isRequired,
    onChange: onChange,
    value: value,
    ref: inputRef
  }, (0, _omit2.default)(otherProps, ['style', 'className', 'placeholderClassName']));

  return _react2.default.createElement(
    _SpacerElement2.default,
    {
      element: 'div',
      spacing: spacing,
      className: styles.textInput,
      adjacentVerticalSpacing: adjacentVerticalSpacing,
      adjacentHorizontalSpacing: adjacentHorizontalSpacing
    },
    isPlaceholder && label && _react2.default.createElement(_Label2.default, { isPlaceholder: true, spacing: '0 0 small' }),
    isPlaceholder && _react2.default.createElement('div', { className: styles.placeholder }),
    !isPlaceholder && label && _react2.default.createElement(
      _Label2.default,
      { 'for': id, spacing: '0 0 small' },
      label
    ),
    !isPlaceholder && _react2.default.createElement(
      'div',
      { className: wrapperClassNames },
      _react2.default.createElement(
        'div',
        { className: styles.iconWrapper },
        icon && _react2.default.createElement(
          'div',
          { className: styles.icon },
          _react2.default.createElement(_Icon2.default, { component: icon, color: 'grey', size: 18 })
        ),
        getFormElement(formProps),
        getIconContent()
      ),
      extraContent && extraContent()
    ),
    isInvalid && getErrorMessage(),
    !isInvalid && helpMessage && getHelpMessage()
  );
}

TextInput.displayName = 'TextInput';
TextInput.propTypes = _extends({
  /**
   * Input type, displaying an appropriate input keyboard where possible.
   */
  type: _propTypes2.default.oneOf(['text', 'password', 'email', 'tel', 'number', 'search']),

  /**
   * A function prop to provide a reference to the underlying DOM element
   * representing the TextInput.
   */
  inputRef: _propTypes2.default.func,

  /**
   * The name of the underlying input element.
   */
  name: (0, _reactProptypeConditionalRequire2.default)(_propTypes2.default.string, function (props) {
    return !props.isPlaceholder;
  }),

  /**
   * The value of the text input.
   */
  value: _propTypes2.default.string,

  /**
   * A label describing the input.
   */
  label: _propTypes2.default.string,

  /**
   * An icon to render before the value of the input.
   */
  icon: _propTypes2.default.func,

  /**
   * The id attribute of the underlying input element. Required if a label prop is present.
   */
  id: (0, _reactProptypeConditionalRequire2.default)(_propTypes2.default.string, function (props) {
    return props.label;
  }),

  /**
   * Number of rows a type `text` input should support, i.e. more than 1 is a textarea.
   */
  rows: _propTypes2.default.number,

  /**
   * The placeholder value of the underlying input element.
   */
  placeholder: _propTypes2.default.string,

  /**
   * Boolean indicating if the current value is invalid.
   */
  isInvalid: _propTypes2.default.bool,

  /**
   * Boolean indicating if a value is required for the field to be valid.
   */
  isRequired: _propTypes2.default.bool,

  /**
   * Boolean indicating if the TextInput should display a loading indicator.
   */
  isLoading: _propTypes2.default.bool,

  /**
   * Render prop for icon content at the end of the TextInput.
   */
  iconContent: _propTypes2.default.func,

  /**
   * Render prop for additional content to render following the TextInput.
   */
  extraContent: _propTypes2.default.func,

  /**
   * An error message to display to indicate the input has an invalid value. Required if the field
   * is invalid.
   */
  errorMessage: (0, _reactProptypeConditionalRequire2.default)(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]), function (props) {
    return props.inValid;
  }),

  /**
   * An optional help message to display underneath the input.
   */
  helpMessage: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),

  /**
   * Boolean for if autocomplete should be disabled on this input.
   */
  isAutoCompleteDisabled: _propTypes2.default.bool,

  /**
   * Boolean for if spellcheck should be disabled on this input. Also disables autocorrect where
   * supported (Safari).
   */
  isSpellCheckDisabled: _propTypes2.default.bool,

  /**
   * An event handler for when the input element changes value.
   */
  onChange: _propTypes2.default.func

}, _SpacerElement2.default.propTypes);

TextInput.defaultProps = _extends({
  type: 'text',
  inputRef: undefined,
  value: '',
  label: undefined,
  icon: undefined,
  id: undefined,
  rows: 1,
  placeholder: '',
  isInvalid: undefined,
  isRequired: false,
  isLoading: false,
  iconContent: undefined,
  extraContent: undefined,
  errorMessage: undefined,
  helpMessage: undefined,
  isAutoCompleteDisabled: false,
  isSpellCheckDisabled: false,
  onChange: function onChange() {
    return undefined;
  }
}, _SpacerElement2.default.defaultProps);